import { z } from '@spcc/core';

export const syncDirectionSchema = z.enum(['outbound', 'inbound']);

export const syncEntityTypeSchema = z.enum([
  'tenant',
  'sales_order',
  'weight_update',
  'material',
  'invoice',
  'balance',
  'pricing',
  'payment',
  'inbound_shipment',
  'goods_receipt',
]);

export const sapOperationSchema = z.enum([
  'create_business_partner',
  'update_business_partner',
  'check_customer_exists',
  'pull_business_partner',
  'create_sales_order',
  'check_customer_contract',
  'create_sales_contract',
  'weight_update_first',
  'weight_update_second',
  'inbound_weight_first',
  'inbound_weight_second',
  'create_goods_receipt',
  'pull_purchase_orders',
  'pull_invoices',
]);

export const httpMethodSchema = z.enum(['GET', 'POST', 'PATCH', 'PUT', 'DELETE']);

export const syncStatusSchema = z.enum(['pending', 'processing', 'completed', 'failed', 'dlq']);

export const circuitBreakerStateSchema = z.enum(['CLOSED', 'OPEN', 'HALF_OPEN']);

export const sapSyncJobDtoSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  direction: syncDirectionSchema,
  entityType: syncEntityTypeSchema,
  entityId: z.string(),
  sapOperation: sapOperationSchema.nullable().optional(),
  eventId: z.string().nullable(),
  status: syncStatusSchema,
  httpMethod: httpMethodSchema.nullable().optional(),
  url: z.string().nullable().optional(),
  requestHeaders: z.record(z.string(), z.string()).nullable().optional(),
  requestPayload: z.unknown().optional(),
  responseStatus: z.number().nullable().optional(),
  responseHeaders: z.record(z.string(), z.string()).nullable().optional(),
  responsePayload: z.unknown().optional(),
  durationMs: z.number().nullable().optional(),
  sapDocumentNumber: z.string().nullable(),
  sapDocumentType: z.string().nullable(),
  attempts: z.number(),
  lastAttemptAt: z.string().nullable(),
  errorMessage: z.string().nullable(),
  errorCode: z.string().nullable(),
  correlationId: z.string().nullable(),
  tenantId: z.string().nullable(),
  completedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SapSyncJobDto = z.infer<typeof sapSyncJobDtoSchema>;

export const sapDlqEntryDtoSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  errorMessage: z.string(),
  errorCode: z.string().nullable(),
  attempts: z.number(),
  lastAttemptAt: z.string().nullable(),
  resolvedAt: z.string().nullable(),
  resolvedBy: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SapDlqEntryDto = z.infer<typeof sapDlqEntryDtoSchema>;

export const circuitBreakerStatusDtoSchema = z.object({
  state: circuitBreakerStateSchema,
  failureCount: z.number(),
  successCount: z.number(),
  lastFailureAt: z.string().nullable(),
  lastStateChange: z.string(),
});

export type CircuitBreakerStatusDto = z.infer<typeof circuitBreakerStatusDtoSchema>;

export const sapPullWatermarkDtoSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  entityType: z.string(),
  lastSyncedAt: z.string(),
  recordsSynced: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SapPullWatermarkDto = z.infer<typeof sapPullWatermarkDtoSchema>;

export const dashboardStatusDtoSchema = z.object({
  circuitBreaker: circuitBreakerStatusDtoSchema,
  syncJobStats: z.record(z.string(), z.record(z.string(), z.number())),
  dlqDepth: z.number(),
  pullWatermarks: z.array(sapPullWatermarkDtoSchema),
});

export type DashboardStatusDto = z.infer<typeof dashboardStatusDtoSchema>;
